import { render, staticRenderFns } from "./FieldsItem.vue?vue&type=template&id=9449c798&lang=pug"
import script from "./FieldsItem.vue?vue&type=script&lang=js"
export * from "./FieldsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports